import {createContext,useContext,useEffect,useState,useCallback,useRef} from "react";
import {api,errMsg} from "@/lib/api";
const AuthCtx=createContext(null);
export function AuthProvider({children}){
 const [user,setUser]=useState(null),[error,setError]=useState(""),[checking,setChecking]=useState(false);
 const alive=useRef(true);
 const check=useCallback(async()=>{
  setChecking(true);setError("");
  try{
   let response;
   try{response=await api.get("/auth/me")}
   catch(e){
    if(![401,403].includes(e.response?.status))throw e;
    await api.post("/auth/refresh");response=await api.get("/auth/me");
   }
   if(alive.current)setUser(response.data);
  }catch(e){
   if(alive.current){
    if([401,403].includes(e.response?.status))setUser(false);
    else setError(errMsg(e));
   }
  }finally{if(alive.current)setChecking(false)}
 },[]);
 useEffect(()=>{
  alive.current=true;check();
  const out=()=>{setUser(false);setError("")};
  window.addEventListener("jarvis:logout",out);
  return()=>{alive.current=false;window.removeEventListener("jarvis:logout",out)};
 },[check]);
 const login=useCallback(async(email,password)=>{
  const r=await api.post("/auth/login",{email,password});setError("");setUser(r.data);
 },[]);
 const logout=useCallback(async()=>{await api.post("/auth/logout").catch(()=>{});setError("");setUser(false)},[]);
 return <AuthCtx.Provider value={{user,login,logout,refresh:check}}>
 {user===null&&error?<main className="min-h-screen grid place-items-center"><section role="alert" className="operations-card"><h1>No se pudo comprobar tu sesión</h1><p>{error}</p><button disabled={checking} onClick={check}>Volver a comprobar sesión</button></section></main>:children}
 </AuthCtx.Provider>;
}
export const useAuth=()=>useContext(AuthCtx);
